"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagPills = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _filterState = require("../util/filter-state.js");

var _testId = require("../util/test-id");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OptionPill = _styledComponents["default"].li.withConfig({
  displayName: "OptionPill",
  componentId: "sc-1ott1mw-0"
})(["&&{display:inline-flex;flex-direction:row;align-items:center;justify-content:flex-start;padding:8px;border:2px solid ", ";border-radius:64px;cursor:pointer;& > ", "{white-space:nowrap;}& > ", "{margin-left:8px;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.scuttleGray200;
}, _baseReactComponents.Copy, _baseReactComponents.Icon);

var ResetPill = (0, _styledComponents["default"])(OptionPill).withConfig({
  displayName: "ResetPill",
  componentId: "sc-1ott1mw-1"
})(["&&{display:none;@media screen and (", "){display:inline-flex;}}"], function (_ref2) {
  var forLargerThanPhone = _ref2.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var Options = _styledComponents["default"].ul.withConfig({
  displayName: "Options",
  componentId: "sc-1ott1mw-2"
})(["&&{list-style-type:none;padding:0 16px;margin:0;display:flex;flex-direction:row;flex-wrap:wrap;align-items:flex-start;justify-content:flex-start;@media screen and (", "){padding:0;}& > ", "{flex:0 0 auto;margin:8px 0 0 0;}& > ", ":not(:last-child){margin-right:16px;}}"], function (_ref3) {
  var forLargerThanPhone = _ref3.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, OptionPill, OptionPill);

var ActiveFiltersLabel = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "ActiveFiltersLabel",
  componentId: "sc-1ott1mw-3"
})(["&{padding:8px 0;text-transform:uppercase;display:none;}@media screen and (", "){display:block;}"], function (_ref4) {
  var forLargerThanPhone = _ref4.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var ActiveFiltersContainer = _styledComponents["default"].div.withConfig({
  displayName: "ActiveFiltersContainer",
  componentId: "sc-1ott1mw-4"
})(["padding:16px 0 0 0;"]);

var TagPills = (0, _styledComponents["default"])((0, _styledComponents.withTheme)(function (_ref5) {
  var _ref5$activeFilters = _ref5.activeFilters,
      activeFilters = _ref5$activeFilters === void 0 ? {} : _ref5$activeFilters,
      activeFiltersLabel = _ref5.activeFiltersLabel,
      _ref5$onChange = _ref5.onChange,
      onChange = _ref5$onChange === void 0 ? function () {} : _ref5$onChange,
      className = _ref5.className,
      theme = _ref5.theme;
  return Object.entries(activeFilters).some(function (_ref6) {
    var _ref7 = (0, _slicedToArray2["default"])(_ref6, 2),
        _ref7$ = _ref7[1],
        options = _ref7$ === void 0 ? [] : _ref7$;

    return options.length > 0;
  }) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(ActiveFiltersContainer, {
    className: className,
    "data-testid": "dropdown-filter:active-filters",
    children: [activeFiltersLabel != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(ActiveFiltersLabel, {
      light: true,
      bold: true,
      "data-testid": "dropdown-filter:active-filters-label",
      children: activeFiltersLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Options, {
      "data-testid": "dropdown-filter:active-filters-list",
      children: [Object.entries(activeFilters).map(function (_ref8) {
        var _ref9 = (0, _slicedToArray2["default"])(_ref8, 2),
            name = _ref9[0],
            options = _ref9[1];

        var testIdName = (0, _testId.formatForTestId)(name);
        var testIdOption = (0, _testId.formatForTestId)(name);
        return options.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(OptionPill, {
            onClick: function onClick() {
              return onChange((0, _filterState.removeFilterOptions)(activeFilters, name, [option]));
            },
            "data-testid": "dropdown-filter:active-filter-".concat(testIdName, ":option-").concat(testIdOption),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
              children: option
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
              name: "actions/circle-delete",
              height: "24",
              width: "24",
              color: theme.scuttleGray400
            })]
          }, "".concat(name, " / ").concat(option));
        });
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ResetPill, {
        onClick: function onClick() {
          return onChange({});
        },
        "data-testid": "dropdown-filter:active-filters-reset",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          children: "Clear All"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: "actions/circle-delete",
          height: "24",
          width: "24",
          color: theme.scuttleGray400
        })]
      })]
    })]
  }) : null;
})).withConfig({
  displayName: "TagPills",
  componentId: "sc-1ott1mw-5"
})([""]);
exports.TagPills = TagPills;
TagPills.displayName = 'TagPills';
//# sourceMappingURL=tag-pills.js.map